import { render, staticRenderFns } from "./wiki_form.vue?vue&type=template&id=0f33dd4e"
import script from "./wiki_form.vue?vue&type=script&lang=js"
export * from "./wiki_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports